<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    @open="onOpen"
    @close="onClose"
    title="编辑节点"
  >
    <el-form
      ref="elForm"
      :model="formData"
      :rules="rules"
      size="medium"
      label-width="100px"
    >
      <el-form-item label="父节点" prop="parentId">
        <el-select
          filterable
          v-model="formData.parentId"
          placeholder="请选择父节点，支持输入名称搜索"
          clearable
          :style="{ width: '100%' }"
        >
          <el-option
            v-for="(item, index) in parentIdOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="节点名称" prop="name">
        <el-input
          v-model="formData.name"
          placeholder="请输入节点名称"
          clearable
          :style="{ width: '100%' }"
        ></el-input>
      </el-form-item>
      <el-form-item label="工地编号" prop="constructionSiteCode">
        <el-input
          v-model="formData.constructionSiteCode"
          placeholder="请输入工地编号"
          clearable
          :style="{ width: '100%' }"
        ></el-input>
      </el-form-item>
      <el-form-item label="项目编号" prop="projectId">
        <el-input
          v-model="formData.projectId"
          placeholder="请输入项目编号"
          clearable
          :style="{ width: '100%' }"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="handelConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { queryNodeCanBeAdded, updateNodeInfo } from '@/api/tree';

export default {
  inheritAttrs: false,
  components: {},
  props: ['nodeId'],
  data() {
    return {
      formData: {
        parentId: undefined,
        name: undefined,
        constructionSiteCode: undefined,
        projectId: undefined
      },
      rules: {
        parentId: [],
        name: [],
        constructionSiteCode: [],
        projectId: []
      },
      parentIdOptions: []
    };
  },
  computed: {},
  watch: {
    nodeId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getCanBeAddedNodes(val);
        }
      }
    }
  },
  created() {},
  mounted() {
    if (this.nodeId) {
      getCanBeAddedNodes(this.nodeId);
    }
  },
  methods: {
    getCanBeAddedNodes(id) {
      const that = this;
      queryNodeCanBeAdded(this.$axios, id).then((res) => {
        const list = res.data.data;
        that.parentIdOptions = list.map((item) => {
          return {
            label: item.name,
            value: item.id
          };
        });
      });
    },
    onOpen() {},
    onClose() {
      this.$refs['elForm'].resetFields();
    },
    close() {
      this.$emit('update:visible', false);
    },
    handelConfirm() {
      const that = this;
      this.$confirm('确认修改当前节点信息吗？').then(() => {
        that.$refs['elForm'].validate((valid) => {
          if (!valid) return;
          // this.close();
          updateNodeInfo(that.$axios, {
            id: that.nodeId,
            parentId: that.formData.parentId || '',
            name: that.formData.name || '',
            constructionSiteCode: that.formData.constructionSiteCode || '',
            projectId: that.formData.projectId || ''
          })
            .then((res) => {
              if (!res.data.code) {
                that.$message.success('修改成功');
                that.$emit('update:visible', false);
              } else {
                that.$message.error(res.data.msg);
              }
            })
            .finally(() => {
              that.$emit('on-submit-finish');
            });
        });
      });
    },
    setFormData(parentId, name) {
        this.formData.parentId = parentId
        this.formData.name = name
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/nodeTree/EditNodeDialog.vue